import React, { useEffect, useMemo, useState } from "react";
import close from "../../../../assets/img/icons/Vector copy.svg";
import CountBox from "../../../dropbox/CountBox";
import IconBox from "../../../shared/IconBox";
import mines from "../../../../assets/img/icons/Vector.svg";
import add from "../../../../assets/img/icons/add.svg";
import Button from "../../../shared/Button";
import { useForm } from "react-hook-form";
import Input from "../../../shared/Input";
import trash from "../../../../assets/img/icons/trash.svg";
import edit from "../../../../assets/img/admin/edit.svg";

const PlaceCapModal = ({ closeModal, setcustomSleep, customSleep }) => {
  const [editItem, setEditItem] = useState();
  const [editMode, setShowEditMode] = useState(false);

  const {
    handleSubmit,
    formState: { errors, isValid },

    control,
    reset
  } = useForm({
    defaultValues: useMemo(
      () => {
        if(editMode){
          return editItem;
        }
       
      },
      [editItem]
    )
  });
  const [count, setCount] = useState(0);
  const [counterror, setcounterror] = useState("");
  const increase = () => {
    setCount(prev => (prev += 1));
  };
  const decrease = () => {
    if (count > 0) {
      setCount(prev => (prev -= 1));
    }
  };
  const onSubmit = data => {
    if (count === 0) {
      setcounterror("تعداد را وارد کنید");
    } else {
      setcounterror("");

      setcustomSleep(prev => [...prev, { name: data.name, count: count }]);
      reset({ name: "" });
      setCount(0);
    }
  };
  const deleteItem = (name)=>{
    setcustomSleep(customSleep.filter(j=>j.name !== name))
  }
  const editItems = (name)=>{
    setShowEditMode(name)
    setEditItem(customSleep.filter(j=>j.name === name)[0])
    setcustomSleep(customSleep.filter(j=>j.name !== name));

   
  }
  useEffect(() => {
    console.log(editItem)
    if(
      editMode
    ){
      reset({
        name:editItem.name
      })
      setCount(editItem.count)
    }
   
  }, [editMode])
  
 const submitEdit = ()=>{

 }

  return (
    <div className="ModalBackground PlaceCapModal">
      <div className="ModalBackground--container p-[25px]">
        <div className="flex justify-between  items-center">
          <h2 className="text-[#292D32] text-[20px] font-[700]">
            سایر موارد : مثل تخت تاشو و ...
          </h2>
          <button onClick={closeModal}>
            <img src={close} />
          </button>
        </div>
        <hr className="my-[20px]" />

        <form onSubmit={handleSubmit(onSubmit)}>
          <Input
            name="name"
            control={control}
            errors={errors}
            placeholder=" وسیله خواب مورد نظر را وارد کنید"
            className="seconadary-input"
            register={{
              required: "وسیله خواب مورد نظر را وارد کنید"
            }}

          />
          <div className="CountBox__container flex justify-between items-center mt-[10px]">
            <div className=" flex justify-between items-center">
              <IconBox onClick={increase} white className="CountBox__iconbox">
                <img width={24} src={add} />
              </IconBox>
              <div className="text-[#51555A] mx-[46px]  text-[16px] w-[120px] text-center ">
                {count === 0 ? "ابتدا موردی وارد کنید" : `${count} مورد`}
              </div>
              <IconBox onClick={decrease} white className="CountBox__iconbox">
                <img width={12} src={mines} />
              </IconBox>
            </div>
            <button
              type="submit"
              className="text-[#00A6A6] cursor-pointer text-[16px] px-[14px] py-[5px]  right-border"
            >
              افزودن
            </button>
          </div>
          <div className="text-[red] mt-[5px] text-[14px]">
            {counterror}
          </div>
        </form>
        <hr className="my-[20px]" />

        {customSleep.map(i =>
          <div className="flex customsleepItem" key={i.name}>
            <div className="w-[20px] h-[20px] customsleepItem-checkitem " />
            <p>
              {i.name}
            </p>
          <div className="flex items-center gap-[10px]">
          <button   onClick={()=>deleteItem(i.name)} >
            <img className="h-[25px]" src={trash}/>
           </button>
           <button onClick={()=>editItems(i.name)}>
             <img className="h-[25px]"  height={20} src={edit}/>
           </button>
          </div>
          </div>
        )}

        <div className="flex gap-[12px] mt-[25px]">
          <Button varient="white" fullwidth onClick={()=>{closeModal();setcustomSleep([])}}>
            انصراف
          </Button>
          <Button varient="primary" onClick={closeModal} fullwidth>
            تایید{" "}
          </Button>
        </div>
      </div>
    </div>
  );
};

export default PlaceCapModal;
